module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraLight.dc8c62c.eot";